"use client";

import { useEffect, useState } from "react";
import { TV_CONFETTI_REPEAT_MS } from "../tv-celebration";

export interface UseTvCelebrationResult {
  /** Changes for every new confetti burst. Zero means no confetti. */
  burst: number;
}

/**
 * Fires a confetti burst as soon as the show is complete, then again every
 * `repeatMs` so people walking into the room still catch it.
 */
export function useTvCelebration(options: {
  complete: boolean;
  enabled: boolean;
  repeatMs?: number;
}): UseTvCelebrationResult {
  const { complete, enabled, repeatMs = TV_CONFETTI_REPEAT_MS } = options;
  const active = complete && enabled;
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    if (!active || repeatMs <= 0) {
      return;
    }
    const id = window.setInterval(() => setCycle((current) => current + 1), repeatMs);
    return () => window.clearInterval(id);
  }, [active, repeatMs]);

  return { burst: active ? cycle + 1 : 0 };
}
